import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Play, Quote } from 'lucide-react';
export function VideoTestimonialSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 bg-gray-50 relative overflow-hidden" data-id="element-113">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-114">
        <div className="text-center mb-16" data-id="element-115">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-4 font-playfair" data-id="element-116">
            What Our Clients Are Saying
          </h2>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto" data-id="element-117"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-118">
          {/* Video Placeholder */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: -30
        }} transition={{
          duration: 0.8
        }} className="relative rounded-xl overflow-hidden shadow-2xl aspect-video bg-gray-900 group cursor-pointer" data-id="element-119">
            <img src="https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80" alt="Boats by George Testimonial" className="w-full h-full object-cover opacity-80 group-hover:opacity-70 transition-opacity duration-300" data-id="element-120" />
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-121">
              <div className="w-20 h-20 bg-[#D4AF37] rounded-full flex items-center justify-center shadow-[0_0_30px_rgba(212,175,55,0.4)] group-hover:scale-110 transition-transform duration-300" data-id="element-122">
                <Play className="w-8 h-8 text-white fill-current ml-1" data-id="element-123" />
              </div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent" data-id="element-124">
              <p className="text-white font-bold text-lg" data-id="element-125">Boats by George</p>
              <p className="text-gray-300 text-sm" data-id="element-126">
                Digital Performance Review
              </p>
            </div>
          </motion.div>

          {/* Quote */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: 30
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-white p-8 rounded-xl border border-gray-200 shadow-lg" data-id="element-127">
            <Quote className="w-12 h-12 text-[#D4AF37] mb-6 opacity-50" data-id="element-128" />
            <blockquote className="text-xl md:text-2xl text-[#0A1628] leading-relaxed mb-8 font-playfair italic" data-id="element-129">
              "Working with Mannix helped us solve a lot of the problems that we
              set out to address. They bring a ton of expertise to the table
              when it comes to industry standards."
            </blockquote>
            <div data-id="element-130">
              <p className="text-[#0A1628] font-bold" data-id="element-131">Adam Pensel</p>
              <p className="text-[#D4AF37] text-sm" data-id="element-132">
                General Manager, Boats by George
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}